import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {rfcFormat} from 'src/app/components/common/validations';
import {SessionService} from 'src/app/services/session.service';
import {PAISES_MUNDO} from '../../../../models/application/countriesWorld';
import {DeviceDetectorService} from 'ngx-device-detector';
import {DialogService} from '../../../../services/dialog.service';

@Component({
    selector: 'app-billing-info',
    templateUrl: './billing-info.component.html',
    styleUrls: ['./billing-info.component.scss']
})
export class BillingInfoComponent implements OnInit {
    @Input() active: boolean;
    acepptTerms = false;
    countries: any;
    form: FormGroup;
    billingData: any;
    billingAdded: boolean;
    billingDataValid = false;
    addBilling = false;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private fb: FormBuilder,
        private sessionService: SessionService,
        private dialogService: DialogService,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.countries = PAISES_MUNDO.sort(
            (a, b) => {
                if (a.name_es > b.name_es) {
                    return 1;
                }
                if (a.name_es < b.name_es) {
                    return -1;
                }
                return 0;
            }
        );
        this.billingData = this.sessionService.getPaymentBilling();
        this.initForm();
    }

    ngOnInit(): void {
        if (this.sessionService.getPaymentBilling() != null &&
            this.sessionService.getPaymentBilling() !== '' &&
            this.sessionService.getPaymentBilling().country !== null &&
            this.sessionService.getPaymentBilling().country !== ''
        ) {
            this.billingData = this.sessionService.getPaymentBilling();
            this.form.setValue(this.billingData);
            this.billingAdded = true;
        } else {
            this.form.reset();
            this.billingAdded = false;
        }
    }

    initForm(): void {
        this.form = this.fb.group({
            country: [this.billingData?.country || '', Validators.compose([Validators.required])],
            state: [this.billingData?.state || '',
                Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(50)])],
            city: [this.billingData?.city || '',
                Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(50)])],
            code: [this.billingData?.code || '', Validators.compose([Validators.required, Validators.maxLength(8)])],
            address: [this.billingData?.address || '', Validators.compose([Validators.required,
                Validators.minLength(2), Validators.maxLength(50)])],
            rfc: [this.billingData?.rfc || '',
                Validators.compose([Validators.required, Validators.maxLength(22)])],
            businessName: [this.billingData?.businessName || '', Validators.compose([Validators.required,
                Validators.minLength(2), Validators.maxLength(50)])]
        });
    }

    saveData(): void {
        if (this.addBilling) {
            if (this.form.valid) {
                this.sessionService.setPaymentBilling(this.form.getRawValue());
                this.billingData = this.sessionService.getPaymentBilling();
                this.billingDataValid = true;
                this.refreshSteps();
            } else {
                this.dialogService.showNotificationDialog('Ups!', 'Todos los campos son requeridos.');
            }
        } else {
            this.sessionService.setPaymentBilling(this.form.getRawValue());
            this.billingData = this.sessionService.getPaymentBilling();
            this.refreshSteps();
        }
        this.addDataLayer();
    }

    refreshSteps(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.billingAdded = steps.billingStep.completed;
    }

    refreshEmpty(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.billingAdded = steps.billingStep.completed = false;
        this.billingDataValid = false;
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {step: 3, option: 'Información de Facturacion'},
                }
            }
        });
    }

}
